







import { defineComponent, computed } from '@vue/composition-api'
import { RouteName, RoutePath } from '@/router'
import Features from '@telia/infra-feature-manager'
import { applyReactInVueWithOptions } from '@/utils/react.utils'
import { GrootLandlordToggle } from 'groot-components'

export default defineComponent({
  components: {
    LandlordToggleWrapper: applyReactInVueWithOptions(GrootLandlordToggle)
  },
  setup (_, context) {
    const landlordChatBotEnabled = computed(() => Features.LANDLORD_CHAT_BOT)
    const isCurrentRouteLandlord = computed(() => context.root.$route.path.includes(RoutePath.LandlordPage))

    const handleClickPrivate = () => {
      if (isCurrentRouteLandlord.value) {
        if (landlordChatBotEnabled.value) {
          const route = context.root.$router.resolve({
            name: RouteName.LandingPage
          })

          window.location.assign(route.href)
        } else {
          context.root.$router.push({
            name: RouteName.LandingPage
          })
        }
      }
    }

    const handleClickLandlord = () => {
      if (!isCurrentRouteLandlord.value) {
        if (landlordChatBotEnabled.value) {
          const route = context.root.$router.resolve({
            name: RouteName.LandlordPage
          })

          window.location.assign(route.href)
        } else {
          context.root.$router.push({
            name: RouteName.LandlordPage
          })
        }
      }
    }

    return {
      isCurrentRouteLandlord,
      handleClickPrivate,
      handleClickLandlord
    }
  }
})
